export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11441.f18114c8.jpg";